import { Fragment } from 'react'
import howToRegister from 'assets/img/train/two-weeks-pd-register.png'

export const courseOverview = [
  {
    tabTitle: 'Key Details',
    tabContent: {
      keyPoints: [
        {
          icon: 'fa-solid fa-map-location-dot',
          point: 'Virtual with live instruction',
        },
        {
          icon: 'fa-solid fa-calendar-days',
          point: 'Coming soon!',
        },
        { icon: 'fa-solid fa-sack-dollar', point: 'FREE for participants' },
        {
          icon: 'fa-solid fa-clipboard-list',
          point: 'Prerequisites: U.S. public high school educators',
        },
      ],
    },
  },
  {
    tabTitle: 'How It Works',
    tabContent: {
      headline: 'Educators participate in three daily components.',
      keyPoints: [
        {
          icon: 'fa-solid fa-person-chalkboard',
          point: 'Lecture',
        },
        {
          icon: 'fa-solid fa-flask',
          point: 'Lab with Teaching Assistant',
        },
        { icon: 'fa-solid fa-diagram-project', point: 'Homework or project' },
      ],
      description: (
        <Fragment>
          <span className="d-block mb-10">
            Class is held daily, Monday - Friday, 11:00 AM - 5:00 PM Eastern
            Standard Time. An additional 10 asynchronous hours to be completed
            during the week.
          </span>
          <span className="d-block mb-10">
            Participants who do not have any prior training in Python will be
            required to complete asynchronous modules and one synchronous
            session during the week prior to the PD.
          </span>
          <span className="d-block">
            At the end of the course, educators will have ML skills and
            knowledge to take back into their classrooms to continue the
            education for their students.
          </span>
        </Fragment>
      ),
      highlightedPoint: [
        // "Upon successful completion of the 2-week course, educators will have the opportunity to receive CEUs.",
      ],
    },
  },
  {
    tabTitle: "What you'll learn",
    tabContent: {
      descriptions: [
        "Educators will develop skills in one of the most cutting-edge tech fields today. They gain knowledge in the hottest AI topics including GenAI, Deep Learning, Neural Networking, Cursors, MCPs & more! They'll also gain practical experience in AI at the intersection of fields such as healthcare, robotics and social media.",
        'In addition, one of the most important topics covered in the course is bias in AI in which educators will learn what it means to become a Responsible AI leader.',
      ],
      pointsList: [
        'GenAI',
        'Deep Learning',
        'Neural Networks',
        'ML Algorithms, such as KNN and k-means clustering',
        'Data visualizations',
      ],
    },
  },
  {
    tabTitle: 'How To Register',
    tabContent: {
      descriptions: [
        'This course is open to high school teachers at any U.S. public or charter high school.',
        "We're looking for participants with enthusiasm to learn skills in the field of AI and a passion to share AI/ML education with your students. No prior coding experience required.",
        'To register:',
        // <Fragment>
        //   <ol>
        //     <li>
        //       Create an account on the Pathfinders website by clicking the
        //       ‘Create Account’ button below.
        //     </li>
        //     <li>
        //       Next, click the ‘Register’ button below & enroll in the course!
        //     </li>
        //   </ol>
        // </Fragment>,
      ],
      highlightedPoint: [
        'Applications are accepted on a rolling basis - the earlier you apply the better chance you have of acceptance!',
        'Click the ‘Register’ button below & enroll in the course!',
        // <Fragment>
        //   If you are a U.S. high school educator at a non-public school, please
        //   complete{' '}
        //   <a href="#" className="text-gold">
        //     this form
        //   </a>{' '}
        //   to express interest & apply.
        // </Fragment>,
      ],
      button: [
        // {
        //   isExternal: true,
        //   buttonText: 'CREATE ACCOUNT',
        //   link: 'https://pathfinders.onwingspan.com/web/en/login',
        // },
        {
          isExternal: true,
          buttonText: '2026 Interest form',
          link: 'https://airtable.com/appdS9n7K25uof6m4/shrk9rCX4MuD6T0HY',
        },
      ],
      // buttonConcatText: '+',
    },
  },
]
